import { render, staticRenderFns } from "./rptcustomerdelivery.vue?vue&type=template&id=13fe3e41"
import script from "./rptcustomerdelivery.vue?vue&type=script&lang=js"
export * from "./rptcustomerdelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports